import { CommonDataAndUtil } from "../../CommonDataAndUtil";
import { CartItem, CartItems  } from "./DataType";

declare var $;
export class CartCookie{
    private name="cart";
    private path={path:'/'};
    constructor(){
        let itemsStr=$.cookie(this.name);
        if(typeof(itemsStr)=="undefined"){
            $.cookie(this.name,"[]",this.path);
        }
    }
    getItems(){
        let itemsStr=$.cookie(this.name);
        return JSON.parse(itemsStr);
    }
    
    addItem(item:CartItem,items:CartItems){
        return this.setItems(items);
    }
    modifyNum(itemId,num,items:CartItems){
        return this.setItems(items)

    }
    updateItem(item:CartItem,items:CartItems){
        return this.setItems(items)
    }
    removeItems(itemIds:Array<string>,items:CartItems){
        return this.setItems(items)
    }

    empty(){
        return this.setItems([]);
    }
/**
 * 
 * @param itemIds 
 * @param mode check,uncheck,checkall,uncheckall
 * @param items
 */
    checkItem(itemId:any,mode="check",items:CartItems){
        return this.setItems(items)
    }

    private setItems(items:CartItems){
        let itemsStr=JSON.stringify(items);
        $.cookie(this.name,itemsStr,this.path);
        return {status:CommonDataAndUtil.STATUS_SUCCESS,info:'操作成功',data:""};
    }
}